module.exports = __webpack_public_path__ + "img/img_holder.00fde6c0.png";